<script lang="ts">
  import HelpText from './HelpText.svelte';
  import ParamButton from './ParamButton.svelte';
  import type MissingParam from '$provider/lib/apis/models/MissingParam';

  interface Props {
    missingParam: MissingParam;
    helpText?: string;
    onclick?: (id: string) => void;
  }

  let { missingParam, helpText = '', onclick }: Props = $props();

  let hasParams = $derived(Array.from(missingParam.params) && missingParam.params.length > 0);
  let hasCombinedParams =
    $derived(Array.from(missingParam.combinedParams) && missingParam.combinedParams.length > 0);

  const onClickParam = (id: string): void => {
    onclick?.(id);
  };
</script>

<div class="param-list">
  {#if hasCombinedParams}
    <div class="param-list-i">
      {#each missingParam.combinedParams as params, index}
        {#if index !== 0}
          <div class="leanText override-leantext">or</div>
        {/if}
        {#each params as param, i}
          <ParamButton {param} {index} onclick={() => onClickParam(param.id)}>
            {#if i !== 0}
              <div class="leanText">+</div>
            {/if}
          </ParamButton>
        {/each}
        <HelpText {helpText} {index} params={missingParam.combinedParams} />
      {/each}
    </div>
  {/if}
  {#if hasParams}
    <div class="param-list-i">
      {#each missingParam.params as param, index}
        <ParamButton {param} {index} onclick={() => onClickParam(param.id)}>
          {#if index !== 0}
            <div class="leanText">or</div>
          {/if}
        </ParamButton>
        <HelpText {helpText} {index} params={missingParam.params} />
      {/each}
    </div>
  {/if}
</div>

<style src="./Param.css">
</style>
